module.exports = __webpack_public_path__ + "img/796767010.6186bf71.jpg";